import classNames from "classnames";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlayCircle} from "@fortawesome/free-solid-svg-icons";
import {Image} from "react-bootstrap";
import React from "react";

import '../../../assets/sass/components/video-player/video-item-base.scss';

const VideoItem = (props) => {
    const {link, thumbnail, onClick} = props;

    return (
        <div className="video-item" onClick={onClick}>
            <div className="thumbnail">
                <div className="overlay scored">
                    <FontAwesomeIcon icon={faPlayCircle} className="icon"/>
                </div>
                <Image src={thumbnail} className="img"/>
            </div>
        </div>
    );
};


const ScoredVideoItem = (props) => {
    const {title, active, link, thumbnail, duration, onClick} = props;
    return (
        <div className={classNames("video-item", active ? 'active' : '')} onClick={onClick}>
            {title && <div className="title">{title}</div>}
            <div className="thumbnail">
                <div className="overlay scored">
                    <FontAwesomeIcon icon={faPlayCircle} className="icon"/>
                </div>
                <Image src={thumbnail} className="img"/>
            </div>
            <div className="duration">{duration} Min</div>
        </div>
    );
};

const NotScoredVideoItem = (props) => {
    const notScoredText = "Not Scored";
    return (
        <div className="video-item">
            <div className="thumbnail">
                <div className="overlay not-scored">
                    <span>{notScoredText}</span>
                </div>
            </div>
        </div>
    );
};


export {VideoItem, NotScoredVideoItem, ScoredVideoItem};
